import type { HTMLAttributes } from "react";
import styles from "./badge.module.scss";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: "default" | "primary" | "success" | "warning" | "error" | "outline";
}

export function Badge({ variant = "default", className, ...props }: BadgeProps) {
  const cls = [styles.badge, styles[variant], className ?? ""].filter(Boolean).join(" ");
  return <span className={cls} {...props} />;
}
